module.exports = __webpack_public_path__ + "media/images/redesign-images/collegiate/collegiate-designs/designs-1-7ac17709856885d4edede44cfe5eae67.jpg";